import { render, staticRenderFns } from "./SeedingCode.vue?vue&type=template&id=2c54246c&scoped=true&"
import script from "./SeedingCode.vue?vue&type=script&lang=js&"
export * from "./SeedingCode.vue?vue&type=script&lang=js&"
import style0 from "./SeedingCode.vue?vue&type=style&index=0&id=2c54246c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c54246c",
  null
  
)

export default component.exports